import { useRef } from 'react';
import PropTypes from 'prop-types';

import { ButtonV2, DownloadIcon, IconButton } from '@utilities';

import Transcript from './components/Transcript';

import styles from './_index.module.scss';

const VideoPlayer = ({
  hasNext = false,
  hasPrevious = false,
  onNext,
  onPrevious,
  publicToken,
  surveyId,
  videoData,
}) => {
  const videoRef = useRef(null);

  const handleSeekToTimestamp = (timestampInSeconds) => {
    if (videoRef.current) {
      videoRef.current.currentTime = timestampInSeconds;
      // Optional: play the video if it's paused
      if (videoRef.current.paused) {
        videoRef.current.play();
      }
    }
  };

  if (!videoData) {
    return (
      <div className={styles['video-player']}>
        <p>No video data available. Please navigate from the video list.</p>
      </div>
    );
  }

  return (
    <div className={styles['video-player']}>
      <div className={styles['video-player-layout']}>
        <div className={styles['video-player-section']}>
          <div className={styles['video-player-header']}>
            <h2>Video Response</h2>
            <div className={styles['video-player-actions']}>
              <IconButton tooltip="Download">
                <DownloadIcon />
              </IconButton>
              <IconButton.Favorite tooltip="Add to favorites" />
            </div>
          </div>
          <div className={styles['video-player-container']}>
            <div className={styles['video-player-element']}>
              {videoData.video_url ? (
                <video controls ref={videoRef} src={videoData.video_url}>
                  <track kind="captions" />
                  Your browser does not support the video tag.
                </video>
              ) : (
                <div className={styles['video-player-no-content']}>No video available</div>
              )}
            </div>
          </div>
        </div>

        <div className={styles['video-player-transcript-wrapper']}>
          <Transcript
            jsonTranscript={videoData.json_transcript}
            onSeekToTimestamp={handleSeekToTimestamp}
          />
        </div>
      </div>

      <div className={styles['video-player-navigation']}>
        <ButtonV2 isDisabled={!hasPrevious} onClick={onPrevious}>
          Previous Video
        </ButtonV2>
        <ButtonV2 isDisabled={!hasNext} onClick={onNext}>
          Next Video
        </ButtonV2>
      </div>
    </div>
  );
};

VideoPlayer.propTypes = {
  hasNext: PropTypes.bool,
  hasPrevious: PropTypes.bool,
  onNext: PropTypes.func,
  onPrevious: PropTypes.func,
  publicToken: PropTypes.string,
  surveyId: PropTypes.string,
  videoData: PropTypes.shape({
    json_transcript: PropTypes.object,
    video_url: PropTypes.string,
  }),
};

export default VideoPlayer;
